import {LineItemStatus} from "utils/LineItemStatus";

// the business flow order (pending -> reserved -> ... ), not the order
// statuses happen to appear in an order's line items
const STATUS_FLOW_ORDER = Object.values(LineItemStatus);

export function sortByStatusFlow([statusA], [statusB]) {
    return STATUS_FLOW_ORDER.indexOf(statusA) - STATUS_FLOW_ORDER.indexOf(statusB);
}
